import { destroy, mutate, query, update, uploadFile } from "../../defaults/fetch";
import { useState, useEffect } from "react";

// Get all stores
export const getStores = async () => {
  const url = `stores`;
  const { data } = await query(url, {});
  return data;
}

export const useGetAllStores = (flag) => {
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getAllStores = async () => {
      setLoading(true);
      const url = `stores`;
      const { data } = await query(url, {});
      setLoading(false);
      setStores(data);
    }
    getAllStores();
  }, [flag])

  return { loading, stores };
}

export const useCreateStore = () => {
  const createStore = async (body) => {
    const url = `stores`;
    const { message } = await mutate(url, true, body);
    return message;
  }
  return createStore;
}

export const useUpdateStore = () => {
  const updateStore = async (id, body) => {
    const url = `stores/${id}`;
    const { message } = await update(url, body);
    return message;
  }
  return updateStore;
}

export const useDeleteStore = () => {
  const deleteStore = async (id) => {
    const url = `stores/${id}`;
    const { message } = await destroy(url);
    return message;
  }
  return deleteStore;
}
